export default {
  // Đúng tuyến
  NormalLine: true,
  // Trái tuyến
  SpecialLine: false,
}
